import ReviewCard from './Review.vue';

export * from './types';
export default ReviewCard;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/review/index.ts